import React, { useState } from 'react';
import { Avatar, Button, Result, Space, Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useUserInventory } from './queries';
import { UserInventoryItem } from './types';
import { formatDateTime } from '../../utils/format';

export function InventoryTab({ userID }: { userID: string }) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const inventory = useUserInventory(userID);
  const items = (inventory.data || []).filter(item => !item.is_default || item.equipped);
  const columns: ColumnsType<UserInventoryItem> = [
    { title: 'Item', dataIndex: 'display_name', render: (name: string, item) => {
      const src = /^(AVATAR_DEFAULT|AVATAR_(0[1-9]|1[0-2]))$/.test(item.asset_id)
        ? `${process.env.PUBLIC_URL || ''}/images/avatars/${item.asset_id}.png`
        : item.image_url || undefined;
      return <Space>{src && <Avatar src={src} shape="square" />}{name}</Space>;
    } },
    { title: 'Asset ID', dataIndex: 'asset_id' },
    { title: 'Type', dataIndex: 'item_type', render: (value: string) => <Tag>{value}</Tag> },
    { title: 'Rarity', dataIndex: 'rarity', render: (value?: string) => value || '—' },
    { title: 'Quantity', dataIndex: 'quantity' },
    { title: 'Equipped', dataIndex: 'equipped', render: (value: boolean) => <Tag color={value ? 'green' : 'default'}>{value ? 'Yes' : 'No'}</Tag> },
    { title: 'Default', dataIndex: 'is_default', render: (value: boolean) => value ? 'Yes' : 'No' },
    { title: 'Acquired', dataIndex: 'acquired_at', render: formatDateTime },
    { title: 'Expires', dataIndex: 'expires_at', render: (value: string | undefined, item) => item.duration === -1 ? 'Permanent' : value ? formatDateTime(value) : '—' },
  ];
  return <>
    <div className="flex justify-end mb-4"><Button loading={inventory.isFetching} onClick={() => inventory.refetch()}>Refresh inventory</Button></div>
    {inventory.error ? <Result status="error" title="Failed to load inventory" subTitle={inventory.error instanceof Error ? inventory.error.message : 'Request failed'} extra={<Button onClick={() => inventory.refetch()}>Retry</Button>} /> :
      <Table rowKey="asset_id" columns={columns} dataSource={items} loading={inventory.isLoading} scroll={{ x: 1100 }} pagination={{ current: Math.min(page, Math.max(1, Math.ceil(items.length / perPage))), pageSize: perPage, showSizeChanger: true, pageSizeOptions: [20, 50, 100], showTotal: total => `${total} items`, onChange: (nextPage, size) => { setPage(size !== perPage ? 1 : nextPage); setPerPage(size); } }} locale={{ emptyText: 'No owned items' }} />}
  </>;
}
